/* tslint:disable */
/* eslint-disable */
/**
 * P4m.Module.Auth.API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import * as runtime from '../runtime';
import {
    type ClaimValuesTree,
    ClaimValuesTreeFromJSON,
    ClaimValuesTreeToJSON,
} from '../models/ClaimValuesTree';
import {
    type ClientAllClaimReadDto,
    ClientAllClaimReadDtoFromJSON,
    ClientAllClaimReadDtoToJSON,
} from '../models/ClientAllClaimReadDto';
import {
    type ClientClaimReadDto,
    ClientClaimReadDtoFromJSON,
    ClientClaimReadDtoToJSON,
} from '../models/ClientClaimReadDto';
import {
    type ClientReadDto,
    ClientReadDtoFromJSON,
    ClientReadDtoToJSON,
} from '../models/ClientReadDto';
import {
    type DataSourceLoadOptions,
    DataSourceLoadOptionsFromJSON,
    DataSourceLoadOptionsToJSON,
} from '../models/DataSourceLoadOptions';

export interface UiApiClientsGetAllClaimsIdClientGetRequest {
    idClient: string;
}

export interface UiApiClientsGetClaimsIdGetRequest {
    id: string;
}

export interface UiApiClientsGetClaimsValuesDxPostRequest {
    typeClaim: string;
    idClient: string;
    dataSourceLoadOptions: DataSourceLoadOptions;
}

export interface UiApiClientsGetClaimsValuesGetRequest {
    typeClaim: string;
    idClient: string;
}

/**
 * 
 */
export class UiApiClientsApi extends runtime.BaseAPI {

    /**
     * Creates request options for uiApiClientsGet without sending the request
     */
    async uiApiClientsGetRequestOpts(): Promise<runtime.RequestOpts> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/ui-api/clients`;

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * Получение списка клиентов
     */
    async uiApiClientsGetRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<ClientReadDto>>> {
        const requestOptions = await this.uiApiClientsGetRequestOpts();
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(ClientReadDtoFromJSON));
    }

    /**
     * Получение списка клиентов
     */
    async uiApiClientsGet(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<ClientReadDto>> {
        const response = await this.uiApiClientsGetRaw(initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for uiApiClientsGetAllClaimsIdClientGet without sending the request
     */
    async uiApiClientsGetAllClaimsIdClientGetRequestOpts(requestParameters: UiApiClientsGetAllClaimsIdClientGetRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['idClient'] == null) {
            throw new runtime.RequiredError(
                'idClient',
                'Required parameter "idClient" was null or undefined when calling uiApiClientsGetAllClaimsIdClientGet().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/ui-api/clients/get-all-claims/{idClient}`;
        urlPath = urlPath.replace('{idClient}', encodeURIComponent(String(requestParameters['idClient'])));

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * Получение списка всех клеймов клиента
     */
    async uiApiClientsGetAllClaimsIdClientGetRaw(requestParameters: UiApiClientsGetAllClaimsIdClientGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<ClientAllClaimReadDto>>> {
        const requestOptions = await this.uiApiClientsGetAllClaimsIdClientGetRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(ClientAllClaimReadDtoFromJSON));
    }

    /**
     * Получение списка всех клеймов клиента
     */
    async uiApiClientsGetAllClaimsIdClientGet(requestParameters: UiApiClientsGetAllClaimsIdClientGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<ClientAllClaimReadDto>> {
        const response = await this.uiApiClientsGetAllClaimsIdClientGetRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for uiApiClientsGetClaimsIdGet without sending the request
     */
    async uiApiClientsGetClaimsIdGetRequestOpts(requestParameters: UiApiClientsGetClaimsIdGetRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling uiApiClientsGetClaimsIdGet().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/ui-api/clients/get-claims/{id}`;
        urlPath = urlPath.replace('{id}', encodeURIComponent(String(requestParameters['id'])));

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * Получение списка клеймов клиента
     */
    async uiApiClientsGetClaimsIdGetRaw(requestParameters: UiApiClientsGetClaimsIdGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<ClientClaimReadDto>>> {
        const requestOptions = await this.uiApiClientsGetClaimsIdGetRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(ClientClaimReadDtoFromJSON));
    }

    /**
     * Получение списка клеймов клиента
     */
    async uiApiClientsGetClaimsIdGet(requestParameters: UiApiClientsGetClaimsIdGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<ClientClaimReadDto>> {
        const response = await this.uiApiClientsGetClaimsIdGetRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for uiApiClientsGetClaimsValuesDxPost without sending the request
     */
    async uiApiClientsGetClaimsValuesDxPostRequestOpts(requestParameters: UiApiClientsGetClaimsValuesDxPostRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['typeClaim'] == null) {
            throw new runtime.RequiredError(
                'typeClaim',
                'Required parameter "typeClaim" was null or undefined when calling uiApiClientsGetClaimsValuesDxPost().'
            );
        }

        if (requestParameters['idClient'] == null) {
            throw new runtime.RequiredError(
                'idClient',
                'Required parameter "idClient" was null or undefined when calling uiApiClientsGetClaimsValuesDxPost().'
            );
        }

        if (requestParameters['dataSourceLoadOptions'] == null) {
            throw new runtime.RequiredError(
                'dataSourceLoadOptions',
                'Required parameter "dataSourceLoadOptions" was null or undefined when calling uiApiClientsGetClaimsValuesDxPost().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['typeClaim'] != null) {
            queryParameters['typeClaim'] = requestParameters['typeClaim'];
        }

        if (requestParameters['idClient'] != null) {
            queryParameters['idClient'] = requestParameters['idClient'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json-patch+json';


        let urlPath = `/ui-api/clients/get-claims-values-dx`;

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: DataSourceLoadOptionsToJSON(requestParameters['dataSourceLoadOptions']),
        };
    }

    /**
     * Получение значений клеймов из другого расширения (DX)
     */
    async uiApiClientsGetClaimsValuesDxPostRaw(requestParameters: UiApiClientsGetClaimsValuesDxPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        const requestOptions = await this.uiApiClientsGetClaimsValuesDxPostRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Получение значений клеймов из другого расширения (DX)
     */
    async uiApiClientsGetClaimsValuesDxPost(requestParameters: UiApiClientsGetClaimsValuesDxPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.uiApiClientsGetClaimsValuesDxPostRaw(requestParameters, initOverrides);
    }

    /**
     * Creates request options for uiApiClientsGetClaimsValuesGet without sending the request
     */
    async uiApiClientsGetClaimsValuesGetRequestOpts(requestParameters: UiApiClientsGetClaimsValuesGetRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['typeClaim'] == null) {
            throw new runtime.RequiredError(
                'typeClaim',
                'Required parameter "typeClaim" was null or undefined when calling uiApiClientsGetClaimsValuesGet().'
            );
        }

        if (requestParameters['idClient'] == null) {
            throw new runtime.RequiredError(
                'idClient',
                'Required parameter "idClient" was null or undefined when calling uiApiClientsGetClaimsValuesGet().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['typeClaim'] != null) {
            queryParameters['typeClaim'] = requestParameters['typeClaim'];
        }

        if (requestParameters['idClient'] != null) {
            queryParameters['idClient'] = requestParameters['idClient'];
        }

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/ui-api/clients/get-claims-values`;

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * Поля объекта \"ClientAllClaimValues\":  ```  {  Value: string;  Description: string;  Children: ClientAllClaimValues[];  }  ```
     * Получение значений клеймов из другого расширения
     */
    async uiApiClientsGetClaimsValuesGetRaw(requestParameters: UiApiClientsGetClaimsValuesGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<ClaimValuesTree>>> {
        const requestOptions = await this.uiApiClientsGetClaimsValuesGetRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(ClaimValuesTreeFromJSON));
    }

    /**
     * Поля объекта \"ClientAllClaimValues\":  ```  {  Value: string;  Description: string;  Children: ClientAllClaimValues[];  }  ```
     * Получение значений клеймов из другого расширения
     */
    async uiApiClientsGetClaimsValuesGet(requestParameters: UiApiClientsGetClaimsValuesGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<ClaimValuesTree>> {
        const response = await this.uiApiClientsGetClaimsValuesGetRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
